export const credentialing_workflow_steps = {
	SELECT_HORSE_SHOW: 0,
	SELECT_TRAINER: 1,
	SELECT_COMPETITOR: 1,
	REVIEW_LIST: 2,
	CREDENTIALING_RECEIPT: 3
}
